import { checkNodeEnv } from './checkNodeEnv';

export const isDevelopment = () => {
  return dependencies.checkNodeEnv('development');
};

export const dependencies = {
  checkNodeEnv,
};
